import React from 'react';
import { connect } from 'react-redux';
import './App.css';
import { debounce } from 'lodash';
import { isMobile } from '../../shared/utils/MobileDetector/MobileDetector';
import Navigation from '../../screens/Navigation/Navigation';
import { fetchUserLocaleAction } from '../../actions/actionCreators';

export class App extends React.Component {
    debouncedResize = debounce(() => {
        const currentMobileState = isMobile();
        if (this.lastVerifiedMobileState !== currentMobileState) {
            this.lastVerifiedMobileState = currentMobileState;
            // this is never something we want do do unthrottled.
            this.forceUpdate();
        }
    }, 100);

    constructor(props) {
        super(props);
        this.lastVerifiedMobileState = undefined;
        this.props.fetchUserLocale();
    }

    componentDidMount() {
        window.addEventListener('resize', this.debouncedResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.debouncedResize);
    }

    render() {
        return (
            <div className="App">
                <Navigation isMobile={isMobile()} />
            </div>
        );
    }
}

/* istanbul ignore next */
const mapStateToProps = () => ({});

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) => ({
    fetchUserLocale: () => dispatch(fetchUserLocaleAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
